/**
 * Recognized callback type
 * @type {{URL: string, FUNCTION: string}}
 */
export const CallbackType = {
    URL: 'URL'
    , FUNCTION: 'FUNCTION'
}